import React, { useState, useRef, useEffect } from "react";
import "./Collapsible.css";

const Collapsible = ({ title, children }) => {
  const [open, setOpen] = useState(false);
  const contentRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState("0px");

  // Adjust the measured scrollHeight to account for any vertical padding
  const extraPaddingPx = 32; // e.g., 2rem top + 2rem bottom = 4rem = 64px (adjust as needed)

  useEffect(() => {
    if (contentRef.current) {
      const contentHeight = contentRef.current.scrollHeight;
      setMaxHeight(
        open ? `${contentHeight + extraPaddingPx}px` : "0px"
      );
    }
  }, [open]);

  const toggleCollapsible = () => {
    setOpen(prev => !prev);
  };

  return (
    <div className={`collapsible ${open ? "open" : ""}`}>
      <div className="collapsible-header" onClick={toggleCollapsible}>
        <span className="collapsible-title">{title}</span>
      </div>

      <div
        className="collapsible-content"
        ref={contentRef}
        style={{ maxHeight }}
      >
        {children}
      </div>
    </div>
  );
};

export default Collapsible;
